import { notificationClient } from '../../api/clients';
import getNotificationSettings from './get-notifications-settings/get-notifications-settings';
import sendNotification from './send-notification/send-notification';
import toggleNotificationForMe from './toggle-notification-for-me/toggle-notification-for-me';
import toggleNotification from './toggle-notification/toggle-notification';
import updateNotification from './update-notification/update-notification';

const notificationService = {
  getNotificationSettings: getNotificationSettings(notificationClient),
  toggleNotification: toggleNotification(notificationClient),
  updateNotification: updateNotification(notificationClient),
  sendNotification: sendNotification(notificationClient),
  toggleNotificationForMe: toggleNotificationForMe(notificationClient),
};

export default notificationService;
